import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

const URL = `reports/worker-summary`;
export const postWorkerSummary = (axios: IAxiosInstance) => {
  return async (
    requestBody: ISchema["#/definitions/IPostWorkerSummaryRequestBody"]
  ) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/IPostWorkerSummaryResponseBody"]
    >(URL, requestBody);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
